(function(window, document, $, undefined){

    'use strict';
    window.main = {};

    main.init = function() {

        main.applyForLoanDropdown();
        main.blogPosition();
        main.headerBackgroundPosition();
        main.minHeightToggle();
        main.accountLoginFocusOut();
        main.accountLoginToggleIcon();
        main.searchToggleFocus();

        $( window ).resize(function() {
            main.blogPosition();
            main.headerBackgroundPosition();
        });
    }

    main.searchToggleFocus = function() {

        $('#collapseSearch').on('show.bs.collapse', function () {
            $('#collapseHelpfulLinks').collapse('hide');
        })

        $('#collapseSearch').on('shown.bs.collapse', function () {
            $('#searchform-1').focus();
        });

        $('#collapseHelpfulLinks').on('show.bs.collapse', function () {
            $('#collapseSearch').collapse('hide');
        });

        $('#collapseHelpfulLinks').on('shown.bs.collapse', function () {

        });


    }

    main.accountLoginToggleIcon = function() {

        $('.account-login').on('show.bs.collapse', function () {

            $('.account-login-icon').html('<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus" class="svg-inline--fa fa-minus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>');
        });

        $('.account-login').on('hidden.bs.collapse', function () {

            $('.account-login-icon').html('<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="svg-inline--fa fa-plus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>');
        });


    }

    main.accountLoginFocusOut = function() {

        $('body').click(function(evt){
            if(!$(evt.target).is('#collapseAccountLogin')) {
                //event handling code
                //$('.account-login').trigger('click');
                console.log('trigger fired');
            }
        });



    }

    main.applyForLoanDropdown = function() {

        $('#apply').change( function() {
            var $url = $(this).val();
            if ($url !== 'hide') {
                window.location.href = $url;
            }
        });

    }

    main.minHeightToggle = function() {

        $('.toggle-content').after( '<a class="read-more" data-toggle="collapse" href="#collapseToggle" role="button" aria-expanded="false" aria-controls="collapseExample">Read More</a>' );

        $('.read-more').on('click', function(e) {
            e.preventDefault();

            $(this).prev().attr('id', 'collapseToggle');
            $(this).prev().toggleClass('expanded');

            if ( $(this).prev().hasClass('expanded')) {
                $(this).text('Show Less');
            } else {
                $(this).text('Read More');
            }

        });
    }

    function getWidth() {
        return Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );
    }

    main.blogPosition =  function() {

        let svg = $('.svg-container svg');
        let svgContainer = $('.svg-container');
        let surveyHeight = $('.survey > div').height();
        let surveyPosition = $('.survey > div');
        let survey = $('.survey');
        let section = $('section.blog');
        let headerSize = $('.featured-box-header').height();
        let arch = $('.arch-bottom').height() - 1;

        console.log(surveyHeight);

        //section.css('margin-top', surveyHeight  - 142);

        svg.css('height', ( 169 / 1920 ) * getWidth() );
        //surveyPosition.css('top', -arch + 1);


    }

    main.headerBackgroundPosition = function() {

        let underlay = $('.underlay');
        let width = getWidth();


        if (width > 1440) {
            let separatorheight = $('.header-separator div').height() - 90;

            underlay.css('top', -separatorheight);
        } else {
            underlay.css('top', -78);

        }



    }

    $(document).on( 'ready', main.init );


})(window, document, jQuery);
